import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule, SecurityContext } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';

import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoaderComponent } from './shared/component/loader/loader.component';
import { AuthService } from './shared/guards/auth.service';
import { HttpClientInterceptorModule } from './shared/interceptor/http.client.interceptor.module';
import { LoaderInterceptor } from './shared/interceptor/loader-interceptor.service';
import { CustomTranslatorService } from './shared/services/custom.translator.service';
import { HttpService } from './shared/services/http.service';
import { LoaderService } from './shared/services/loader.service';
import { MasterService } from './shared/services/masters.service';
import { ToastrMessageService } from './shared/services/toastr.service';
import { UrlService } from './shared/services/url.service';
import { SharedModule } from './shared/shared.module';

import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MarkdownModule, SANITIZE } from 'ngx-markdown';
import { OktaLoginService } from './shared/guards/okta.login.service';

import { MsalGuardConfiguration, MsalInterceptorConfiguration, MsalModule, MsalService } from '@azure/msal-angular';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { LayoutService } from './shared/services/layout.service';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
// AoT requires an exported function for factories
// export function createTranslateLoader(http: HttpClient) {
// 	// return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// 	return new TranslateHttpLoader();
// }

// MSAL Instance configuration
const msalInstance: IPublicClientApplication = new PublicClientApplication({
	auth: {
		clientId: environment.azureLoginConf.clientId,
		authority: environment.azureLoginConf.authority,
		redirectUri: environment.azureLoginConf.redirectUri,
	}
});

// Guard configuration
const guardConfig: MsalGuardConfiguration = {
	interactionType: InteractionType.Redirect,
	authRequest: {
		scopes: ['User.Read'] // Adjust scopes based on permissions
	}
};

// Interceptor configuration
const interceptorConfig: MsalInterceptorConfiguration = {
	interactionType: InteractionType.Redirect,
	protectedResourceMap: new Map([
		// Define the API endpoints that need token injection here
		['https://graph.microsoft.com/v1.0/me', ['User.Read']],
	])
};

@NgModule({
	declarations: [
		AppComponent,
		LoaderComponent
	],
	imports: [
		RouterModule,
		FormsModule,
		BrowserModule,
		NgSelectModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		HttpClientModule,
		ToastrModule.forRoot({
			onActivateTick: true,  // fixes NG0100 on Toast host binding
		}),
		HttpClientModule,
		// DatepickerModule.forRoot(),
		HttpClientInterceptorModule.forRoot(),
		SharedModule,
		// TranslateModule.forRoot({
		// 	defaultLanguage: 'en',
		// 	loader: {
		// 		provide: TranslateLoader,
		// 		useFactory: (createTranslateLoader),
		// 		deps: [HttpClient]
		// 	}
		// }),
		TranslateModule.forRoot({
			fallbackLang: 'en',
			loader: {
			  provide: TranslateLoader,
			  useClass: TranslateHttpLoader
			}
		  }),
		MarkdownModule.forRoot({
			sanitize: {
				provide: SANITIZE,
				useValue: SecurityContext.NONE
			}
		}),
		MsalModule.forRoot(msalInstance, guardConfig, interceptorConfig),
	],
	exports: [
		LoaderComponent

	],
	providers: [
		ToastrMessageService,
		CustomTranslatorService,
		HttpService,
		UrlService,
		LoaderService,
		AuthService,
		MasterService,
		MsalService,
		OktaLoginService,
		LayoutService,
		{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
		provideTranslateHttpLoader({
			prefix: './assets/i18n/',
			suffix: '.json'
		  }),
		providePrimeNG({
			theme: {
				preset: Aura,
				options: {
					darkModeSelector: false
				}
			}
		}),
	],
	bootstrap: [AppComponent]
})
export class AppModule { }